import { ComponentProps } from 'react';

import DonutChart from './DonutChart';
import { processEntries } from './utils';

import ScrollContainer from '~/components/scales/ScrollContainer';

type Props = Pick<
  ComponentProps<typeof DonutChart>,
  'diameter' | 'entries' | 'formatValue' | 'hasOverflow' | 'isSorted'
>;

export default function DonutChartLegend(props: Props) {
  const { entries, formatPercent } = processEntries(
    props.entries,
    props.isSorted,
    props.hasOverflow
  );
  const flatEntries = entries.flatMap((entry) => ('entries' in entry ? entry.entries : entry));

  return (
    <div className="flex h-full w-full flex-col" style={{ maxHeight: props.diameter }}>
      {/* Header */}
      <div className="grid w-full grid-cols-[1fr_auto_auto]">
        <div className="p-2">Costs</div>
        <div className="p-2 text-right">Total</div>
        <div className="w-[71px] p-2 text-right">Percent</div>
        <Divider />
      </div>
      {/* Entries */}
      <ScrollContainer direction="vertical">
        <div className="grid h-full w-full grid-cols-[1fr_auto_auto]">
          {flatEntries.map((entry) => (
            <div key={entry.label} className="contents">
              <div className="flex items-center gap-2 p-2">
                {entry.color && (
                  <div className="h-2 w-2" style={{ backgroundColor: entry.color }} />
                )}
                <div>{entry.label}</div>
              </div>
              <div className="p-2 text-right">
                {props.formatValue ? props.formatValue(entry.value) : entry.value}
              </div>
              <div className="w-[71px] p-2 text-right">{formatPercent(entry.value)}</div>
              <Divider />
            </div>
          ))}
        </div>
      </ScrollContainer>
    </div>
  );
}

function Divider() {
  return <div className="col-span-3 h-[1px] w-full bg-border-default" />;
}
